import { userEndpoint } from '@/ui/core/config'
import { User, UserSchema } from '@/shared/types'
import { AuthenticationService } from './AuthService'

export interface UserClient {
  getUser(): Promise<User>
  updateUser(user: Partial<User>): Promise<void>
}

export class DefaultUserClient implements UserClient {
  auth: AuthenticationService

  constructor(auth: AuthenticationService) {
    this.auth = auth
  }

  public async getUser(): Promise<User> {
    const userId = await this.auth.getUser()
    const user = await this.getUserById(userId)
    return user
  }

  private async getUserById(id: string): Promise<User> {
    const jwtToken = await this.getTokenOrThrow()
    const params = new URLSearchParams({ id: id }).toString()
    const result = await fetch(`${userEndpoint}?${params}`, {
      method: 'GET',
      headers: {
        Authorization: jwtToken,
      },
    })
    const user = UserSchema.parse(await result.json())
    return user
  }

  public async updateUser(user: Partial<User>): Promise<void> {
    const jwtToken = await this.getTokenOrThrow()

    await fetch(new URL(userEndpoint), {
      method: 'PUT',
      body: JSON.stringify(user),
      headers: {
        Authorization: jwtToken,
      },
    })
  }

  private async getTokenOrThrow(): Promise<string> {
    const jwtToken = await this.auth.getJWT()
    if (!jwtToken) {
      throw new Error('Missing token')
    }
    return jwtToken
  }
}
